import React from 'react';
import { observer, inject } from 'mobx-react';

import { Box } from 'grommet';
import styled from 'styled-components';

const StyledBox = styled(Box)`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: -1;
  background: repeating-linear-gradient(
    -55deg,
    #e6e6e6,
    #e6e6e6 10px,
    #e9e9e9 10px,
    #e9e9e9 20px
  );
`;

function Underlay({ AppState }) {
  return (
    (AppState.isUserBookmarking || AppState.isBookmarkingMenuBar) && (
      <StyledBox elevation="small" fill="vertical" width="large" />
    )
  );
}

export default inject('AppState')(observer(Underlay));



// WEBPACK FOOTER //
// ./src/app/components/Underlay.js